import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import ProfileReservedHistory from "../ProfileReservedHistory/ProfileReservedHistory";
import ProfileUserFavorites from "../ProfileUserFavorites/ProfileUserFavorites";
import ProfileInformation from "../ProfileInformation/ProfileInformation";

import "./ProfilePanel.scss";
import ProfileChangePassword from "../ProfileChangePassword/ProfileChangePassword";
import ProfileChangeBasePassword from "../ProfileChangeBasePassword/ProfileChangeBasePassword";

const ProfilePanel = (props) => {
  const [data, setData] = useState([]);
  const [orderHistory, setOrderHistory] = useState([]);
  useEffect(() => {
    setData(props.data);
    setOrderHistory(props.orderHistory);
  }, [props.data, props.orderHistory]);
  if (props.page == "reservedhistory") {
    return (
      <div className="profilePanel">
        <ProfileReservedHistory action={props.reservedHistoryAction} data={orderHistory} />
      </div>
    );
  } else if (props.page == "userInfo") {
    return (
      <div className="profilePanel">
        <ProfileInformation />
      </div>
    );
  } else if (props.page == "userFavorites") {
    return (
      <div className="profilePanel">
        <ProfileUserFavorites data={props.data} />
      </div>
    );
  } else if (props.page == "changePassword") {
    return (
      <div className="profilePanel">
        <ProfileChangePassword />
      </div>
    );
  } else if (props.page == "changeBasePassword") {
    return (
      <div className="profilePanel">
        <ProfileChangeBasePassword />
      </div>
    );
  }
};

export default React.memo(withRouter(ProfilePanel));
